import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, Button, Row, Col } from 'antd';
import DatePicker from 'antd/lib/date-picker';
import moment from 'moment';
import get from 'lodash/get';

const { RangePicker } = DatePicker;

class NewFilterDatePicker extends Component {
  _onValidate = (err, formValues) => {
    const { onSubmitForm, options } = this.props;
    if (!err) {
      const values = [];
      let customLabel = '';

      formValues.rangePicker.forEach(x => {
        const date = moment(x).format(get(options, 'format', 'YYYY-MM-DD'));
        values.push(date);
      });

      customLabel = `${values[0]} to ${values[1]}`;

      onSubmitForm(values, customLabel);
    }
  };

  handleSubmit = e => {
    e.preventDefault();
    const {
      form: { validateFields },
    } = this.props;

    validateFields(this._onValidate);
  };

  disabledDate = current => current > moment();

  _renderForm = () => {
    const { onCancelForm, options } = this.props;
    const { getFieldDecorator } = this.props.form;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col>
            <Form.Item required={false} colon={false}>
              {getFieldDecorator('rangePicker', {
                rules: [
                  {
                    required: true,
                    message: 'date required',
                  },
                ],
              })(
                <RangePicker
                  className="date-picker-style"
                  disabledDate={this.disabledDate}
                  showTime={get(options, 'showTime')}
                  ranges={
                    get(options, 'ranges') || {
                      Today: [moment().startOf('day'), moment().endOf('day')],
                      'Last 7 Day': [moment().subtract(7, 'days'), moment()],
                      'Last 30 Day': [moment().subtract(30, 'days'), moment()],
                      'This Month': [
                        moment().startOf('month'),
                        moment().endOf('month'),
                      ],
                    }
                  }
                />,
              )}
            </Form.Item>
          </Col>

          <Button className="btn cancel-btn" onClick={onCancelForm}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit" className="btn">
            Submit
          </Button>
        </Row>
      </Form>
    );
  };

  render() {
    return <div>{this._renderForm()}</div>;
  }
}

NewFilterDatePicker.propTypes = {
  form: PropTypes.object,
  onCancelForm: PropTypes.func,
  onSubmitForm: PropTypes.func,
  options: PropTypes.object,
};

export default NewFilterDatePicker;
